import './Logo.scss'

import React from 'react'
import {ReactComponent as LogoEn} from '../../assets/images/logo_en.svg'
import {ReactComponent as LogoEs} from '../../assets/images/logo_es.svg'
import {ReactComponent as LogoFr} from '../../assets/images/logo_fr.svg'
import {ReactComponent as LogoNl} from '../../assets/images/logo_nl.svg'
import {useLanguage, useTranslation} from '../../util/i18n'
import {Link} from '../../util/link'
import {style} from '../../util/style'

const styles = style('logo')

export const Logo: React.FC<{
	onClick?: () => void
	className?: string
	title?: string
}> = ({onClick, className, title}) => {
	const language = useLanguage()
	const t = useTranslation()

	return (
		<div className={styles().with(className)}>
			<Link
				to={language ? `/${language}/` : '/'}
				onClick={onClick}
				title={title || t.project_name}
				className={styles('link')}
			>
				{switchLogo()}
			</Link>
		</div>
	)
}

function switchLogo() {
	const language = useLanguage()

	switch (language) {
		case 'fr':
			return <LogoFr />
		case 'en':
			return <LogoEn />
		case 'es':
			return <LogoEs />
		default:
			return <LogoNl />
	}
}
